import { Component, Input, forwardRef } from '@angular/core';
import { DashboardBaseComponent } from '../shared/dashboard-base-component';
import {ChartLoadingComponent} from "../chart-loading/chart-loading.component";
import {NgClass, NgTemplateOutlet} from "@angular/common";

export interface PanelInsightsItem {
  headline: string;
  description: string;
  cssClass: string;
}

export interface PanelInsightsConfig {
  title: string;
  sub?: string;
  layout?: 'list' | 'grid';
  pills?: string[];
  items ?: PanelInsightsItem[];
}

@Component({
  selector: 'app-panel-insights',
  templateUrl: './panel-insights.component.html',
  styleUrls: ['./panel-insights.component.scss'],
  standalone: true,
  imports: [
    ChartLoadingComponent,
    NgClass,
    NgTemplateOutlet
  ],
  providers: [
    {
      provide: DashboardBaseComponent,
      useExisting: forwardRef(() => PanelInsightsComponent)
    }
  ]
})
export class PanelInsightsComponent extends DashboardBaseComponent {
  isLoading = true;

  private _config!: PanelInsightsConfig;

  @Input() set config(val: PanelInsightsConfig) {
    this._config = val;
    if (val?.items) {
      this.isLoading = false;
      this.isLoaded = true;
    }
  }
  get config() { return this._config; }
}
